// @file Global commands that are available to every logged in user

import { copyToClipboard } from '@@/bits/clipboard'
import { navigateTo } from '@@/bits/location'
import { getVuexStore } from '@@/bits/pinia'
import { CommandLevel } from '@@/enums'
import { useDashLayoutPickerStore } from '@@/pinia/dash_layout_picker_store'
import type { Command, WallViz } from '@@/types'
import type { RootState } from '@@/vuexstore/surface/types'

const navigateToUrl = (url: string): (() => void) => {
  return () => navigateTo(url, { target: '_blank' })
}

export const commands: Command[] = [
  {
    name: 'Go to "Basic" settings',
    description: 'Navigate to your account basic settings',
    icon: 'profile_filled',
    level: CommandLevel.Account,
    action: navigateToUrl('/dashboard/settings/basic'),
  },
  {
    name: 'Go to "Password" settings',
    description: 'Navigate to your account password settings',
    icon: 'password_filled',
    level: CommandLevel.Account,
    action: navigateToUrl('/dashboard/settings/password'),
  },
  {
    name: 'Go to "Notifications" settings',
    description: 'Navigate to your account notifications settings',
    icon: 'bell_filled',
    level: CommandLevel.Account,
    action: navigateToUrl('/dashboard/settings/notifications'),
  },
  {
    name: 'Go to "Billing" settings',
    description: 'Navigate to your account billing settings',
    icon: 'gear_filled',
    level: CommandLevel.Account,
    action: navigateToUrl('/dashboard/settings/billing'),
  },
  {
    name: 'Create a padlet',
    description: 'Create a new padlet',
    icon: 'plus_thick',
    level: CommandLevel.Padlet,
    action: (
      { viz, groupBySection }: { viz: WallViz; groupBySection: boolean } = { viz: 'grid', groupBySection: true },
    ) => {
      // Create a random wall
      void useDashLayoutPickerStore().createWall({ viz, groupBySection })
    },
  },
  {
    name: 'Copy link to my profile',
    description: 'Copy the link to your profile',
    icon: 'link_filled',
    level: CommandLevel.Account,
    action: () => {
      // TODO: replace padlet.com with actual domain
      void copyToClipboard(`https://padlet.com/${(getVuexStore() as any)?.getters.user.username as string}`)
    },
  },
  {
    name: 'My profile',
    description: 'Navigate to your profile page',
    icon: 'profile_filled',
    level: CommandLevel.Account,
    action: () => {
      navigateToUrl(`/${getVuexStore<RootState>()?.getters.user.username as string}`)()
    },
  },
  {
    name: 'Create new team or classroom',
    description: 'Create new team or classroom and invite people to join',
    icon: 'group_filled',
    level: CommandLevel.Account,
    action: navigateToUrl('/account/create'),
  },
  {
    name: 'Go to Feature Flags',
    description: 'Navigate to the feature flags page',
    icon: 'flag_filled',
    level: CommandLevel.Account,
    action: navigateToUrl('/area51/feature_flags'),
  },
]
